/**
 * Service providers (BE-3a) — who government fees, fines and add-ons are paid to.
 * Government portals are seeded per TC on the first list call; their name and type are fixed.
 */

import ApiService from '../api.service';
import { keysCamelToSnake, unwrapData, unwrapList } from '../../utils/apiConvert';

export const serviceProviderService = {
  list: async () => unwrapList(await ApiService.get('/api/service-providers')).items,

  // data: { name, type, contactInfo, active }
  create: async (data) => unwrapData(await ApiService.post('/api/service-providers', keysCamelToSnake(data))),

  update: async (id, data) => unwrapData(await ApiService.put(`/api/service-providers/${id}`, keysCamelToSnake(data))),
};

export default serviceProviderService;
